__turbopack_context__.v({
  "address": "SearchStoreCard-module-scss-module__wc-tVG__address",
  "card": "SearchStoreCard-module-scss-module__wc-tVG__card",
  "image": "SearchStoreCard-module-scss-module__wc-tVG__image",
  "imagePlaceholder": "SearchStoreCard-module-scss-module__wc-tVG__imagePlaceholder",
  "imageWrapper": "SearchStoreCard-module-scss-module__wc-tVG__imageWrapper",
  "info": "SearchStoreCard-module-scss-module__wc-tVG__info",
  "name": "SearchStoreCard-module-scss-module__wc-tVG__name",
  "phone": "SearchStoreCard-module-scss-module__wc-tVG__phone",
});
